import { baseApi } from './baseApi'
import { IProductGroup } from '../../types/app'
import { IProduct, IProductsParams } from '../../types/products'

export const productsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProducts: builder.query<IProductGroup[], IProductsParams | void>({
      query: (params) => ({
        url: '/products',
        params: params || undefined,
      }),
      providesTags: ['Products'],
    }),
    getProductById: builder.query<IProduct, string>({
      query: (id) => `/products/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'Products', id }],
    }),
    createProduct: builder.mutation<IProduct, FormData>({
      query: (params) => ({
        url: '/products',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['Products'],
    }),
    deleteProduct: builder.mutation<void, string>({
      query: (id) => ({
        url: `/products/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Products'],
    }),
    editProduct: builder.mutation<
      IProduct,
      { params: FormData | Record<string, unknown>; id: string }
    >({
      query: ({ params, id }) => ({
        url: `/products/${id}`,
        method: 'PUT',
        body: params,
      }),
      invalidatesTags: ['Products'],
    }),
  }),
})

export const {
  useGetProductsQuery,
  useGetProductByIdQuery,
  useCreateProductMutation,
  useDeleteProductMutation,
  useEditProductMutation,
} = productsApi
